import React from 'react';
import { ServiceFilters } from '../../../../app/models/Service';
import ButtonSearchFilter from '../../../../components/buttons/ButtonSearchFilter';

type Props = {
    filter: ServiceFilters;
    setFilter: (filter: ServiceFilters) => void;
    onSearch: () => void;
};

type FilterKey = 'id' | 'name' | 'sector' | 'item_category';

const ServiceFilter = ({ filter, setFilter, onSearch }: Props) => {
    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        const key = name as FilterKey;
        const next: Partial<ServiceFilters> = { ...filter, page: 1 };
        if (key === 'id') {
            next.id = value === '' ? null : parseInt(value, 10) || null;
        } else {
            (next as Record<string, unknown>)[key] = value;
        }
        setFilter(next as ServiceFilters);
    };

    const doSearch = (e?: React.FormEvent) => {
        e?.preventDefault?.();
        onSearch();
    };

    return (
        <form onSubmit={doSearch}>
            <div className="row g-2 align-items-end">
                <div className="col-md-auto">
                    <label className="form-label small mb-1" htmlFor="id">
                        Id
                    </label>
                    <input
                        type="text"
                        id="id"
                        name="id"
                        className="form-control form-control-sm"
                        placeholder="Ej: 1"
                        value={filter.id != null ? String(filter.id) : ''}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-auto">
                    <label className="form-label small mb-1" htmlFor="name">
                        Nombre
                    </label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control form-control-sm"
                        placeholder="Ej: Servicio 1"
                        value={filter.name ?? ''}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-auto">
                    <label className="form-label small mb-1" htmlFor="sector">
                        Sector
                    </label>
                    <input
                        type="text"
                        id="sector"
                        name="sector"
                        className="form-control form-control-sm"
                        placeholder="Ej: Agricultura"
                        value={filter.sector ?? ''}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-auto">
                    <label className="form-label small mb-1" htmlFor="item_category">
                        Categoría
                    </label>
                    <input
                        type="text"
                        id="item_category"
                        name="item_category"
                        className="form-control form-control-sm"
                        placeholder="Ej: Semillas"
                        value={filter.item_category ?? ''}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-auto">
                    <ButtonSearchFilter callbackSearch={doSearch} />
                </div>
            </div>
        </form>
    );
};

export default ServiceFilter;
